import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-explore-four-section',
  templateUrl: './explore-four-section.component.html',
  styleUrls: ['./explore-four-section.component.scss']
})
export class ExploreFourSectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
